/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PhoneOutput.vue?vue&type=template&id=d5cf87dc"
import script from "./PhoneOutput.vue?vue&type=script&setup=true&lang=ts"
export * from "./PhoneOutput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports